export default {
    getLiquidationAuctionLotsList: ({liquidationAuctionLotsList}) => liquidationAuctionLotsList,
};
